<template>
  <v-dialog
    :max-width="maxWidth"
    :value="dialog"
    v-bind="$attrs"
    width="unset"
    @click:outside="closeDialog"
    @keydown.esc="closeDialog"
  >
    <v-card>
      <v-card-title>{{ title }}</v-card-title>
      <v-card-text v-if="description">
        {{ description }}
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn :disabled="loading" color="" text @click="closeDialog">
          Cancel
        </v-btn>
        <v-btn :loading="loading" color="primary" text @click="confirmAction">
          Confirm
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmDialog',
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: undefined,
    },
    maxWidth: {
      type: String,
      default: '90%',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    closeDialog() {
      this.$emit('closeDialog');
    },
    confirmAction() {
      this.$emit('confirmAction');
    },
  },
};
</script>

<style scoped></style>
